export default __webpack_public_path__ + "static/oo-logo-combined-ba14c70e37d255178298d198addf65f8.svg";